export default __webpack_public_path__ + "static/media/crayfishery.231c3df3.svg";